module.exports = __webpack_public_path__ + "static/features-bg-top-22e0e63351bcb007d3a55cbc65ba4162.png";